import { Routes } from "@angular/router";
import { ChatPageComponent } from "./features/chat/chat-page.component";

const supportedLocales = ["es", "de", "fr", "it", "pt-br", "ja"];

export const appRoutes: Routes = [
  {
    path: "",
    loadComponent: () =>
      import("./features/landing/landing.component").then(
        (m) => m.LandingComponent,
      ),
  },
  {
    path: "chat",
    component: ChatPageComponent,
  },
  {
    path: "video",
    loadComponent: () =>
      import("./features/video/video-page.component").then(
        (m) => m.VideoPageComponent,
      ),
  },
  {
    path: "pages",
    loadComponent: () =>
      import("./features/pages/pages-directory.component").then(
        (m) => m.PagesDirectoryComponent,
      ),
  },
  {
    path: "blog",
    loadComponent: () =>
      import("./features/blog/blog-page.component").then(
        (m) => m.BlogPageComponent,
      ),
  },
  {
    path: "about",
    loadComponent: () =>
      import("./features/about/about-page.component").then(
        (m) => m.AboutPageComponent,
      ),
  },
  ...[
    "omegle-alternative",
    "ometv-alternative",
    "chatroulette-alternative",
    "emerald-chat-alternative",
    "monkey-app-alternative",
  ].map((path) => ({
    path,
    loadComponent: () =>
      import("./features/alternatives/alternative-page.component").then(
        (m) => m.AlternativePageComponent,
      ),
  })),
  ...[
    "chat-with-strangers",
    "random-chat",
    "anonymous-chat",
    "make-friends-online",
  ].map((path) => ({
    path,
    loadComponent: () =>
      import("./features/explore/explore-page.component").then(
        (m) => m.ExplorePageComponent,
      ),
  })),
  ...[
    "safety-tips",
    "privacy",
    "terms",
    "community-guidelines",
    "cookie-policy",
    "contact",
  ].map((path) => ({
    path,
    loadComponent: () =>
      import("./features/info/info-page.component").then(
        (m) => m.InfoPageComponent,
      ),
  })),
  ...supportedLocales.map((locale) => ({
    path: `${locale}/chat`,
    component: ChatPageComponent,
  })),
  ...supportedLocales.flatMap((locale) => [
    {
      path: `${locale}/:slug/:childSlug`,
      loadComponent: () =>
        import("./features/seo/seo-page.component").then(
          (m) => m.SeoPageComponent,
        ),
    },
    {
      path: `${locale}/:slug`,
      loadComponent: () =>
        import("./features/seo/seo-page.component").then(
          (m) => m.SeoPageComponent,
        ),
    },
  ]),
  {
    path: ":slug/:childSlug",
    loadComponent: () =>
      import("./features/seo/seo-page.component").then(
        (m) => m.SeoPageComponent,
      ),
  },
  ...supportedLocales.map((locale) => ({
    path: locale,
    loadComponent: () =>
      import("./features/seo/seo-page.component").then(
        (m) => m.SeoPageComponent,
      ),
  })),
  {
    path: ":slug",
    loadComponent: () =>
      import("./features/seo/seo-page.component").then(
        (m) => m.SeoPageComponent,
      ),
  },
  { path: "**", redirectTo: "" },
];
